var path = '/Users/saulsoto/Documents/workspace/spa/spa-frontend/src/app.html';
var html = "<div ngsf-fullscreen=fullscreenCtrl class=fullscreen-container> <ui-view></ui-view> <div id=modals></div> <a ng-hide ng-click=fullscreenCtrl.toggleFullscreen() id=fullscreen-btn-hidden title=Fullscreen></a> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app.html
// module id = 844
// module chunks = 0